import { Currency } from "@redotech/money/currencies";
import { StorefrontCheckoutTextUtils } from "@redotech/redo-storefront-widget-common/storefront-checkout-text-utils";
import * as React from "react";

export const FlexibleCheckoutButtons = ({
  onClickCoverage,
  onClickNoCoverage,
  isCoverage,
  dataTarget,
  coveragePrice,
  cartTotal,
  cartTotalPreDiscount,
  compareAtPrice,
  html,
  customCss,
  currency,
  dueLaterTotal,
  coverageCreditAmount,
}: {
  onClickCoverage: (event: React.MouseEvent) => void;
  onClickNoCoverage: (event: React.MouseEvent) => void;
  isCoverage: boolean;
  dataTarget?: string;
  coveragePrice: number;
  cartTotal: number;
  cartTotalPreDiscount: number;
  compareAtPrice: number;
  html: string;
  customCss?: string;
  currency: Currency;
  dueLaterTotal: number;
  coverageCreditAmount: number;
}) => {
  // replace html here then place.
  html = StorefrontCheckoutTextUtils.fillTemplateVariables({
    text: html,
    currency,
    coveragePrice,
    cartTotal,
    cartTotalPreDiscount,
    dueLaterTotal,
    coverageCreditAmount,
    compareAtPrice,
  });

  return (
    <>
      {customCss ? <style>{customCss}</style> : null}
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        data-target={`${dataTarget || (isCoverage ? "coverage-button" : "non-coverage-button")}`}
        onClick={isCoverage ? onClickCoverage : onClickNoCoverage}
      />
    </>
  );
};
